import { LatLngLiteral } from '@googlemaps/google-maps-services-js';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  ProjectServiceCreateResponseJson,
  ProjectServiceListRequestJson,
} from '@vmspdb/definitions';
import { ApiPaginated } from '@vmspdb/ui/domain';

export const PaginatedProjectActions = createActionGroup({
  source: 'PaginatedProject',
  events: {
    Nothing: emptyProps(),
    Cancel: emptyProps(),
    'List PaginatedProjects': props<{
      params: ProjectServiceListRequestJson;
    }>(),
    'List PaginatedProjects Success': props<{
      data: ApiPaginated<ProjectServiceCreateResponseJson>;
    }>(),
    'List PaginatedProjects Failure': props<{ error: unknown }>(),
    'Set Ref Geopoint': props<{ refGeoPoint?: LatLngLiteral }>(),
  },
});
